import React from 'react';

const SupportHours = () => {
  const channels = [
    {
      icon: '✉',
      title: 'E-post',
      desc: 'Svar innen 24 timer på hverdager',
      detail: 'support@nordpass.no',
      color: '#3B6FD4'
    },
    {
      icon: '☎',
      title: 'Telefon',
      desc: 'Direkte linje til supportteamet',
      detail: '+47 22 00 47 00',
      color: '#E8941A'
    },
    {
      icon: '◈',
      title: 'Live chat',
      desc: 'Tilgjengelig i appen og på nett',
      detail: 'Man–Fre 08–17',
      color: '#3B6FD4'
    }
  ];

  const social = [
    { symbol: 'Fb', label: 'Facebook', sub: '/nordpass.no' },
    { symbol: 'Tw', label: 'Twitter / X', sub: '@nordpass_no' },
    { symbol: 'In', label: 'Instagram', sub: '@nordpass.no' },
    { symbol: 'Li', label: 'LinkedIn', sub: 'NordPass AS' }
  ];

  return (
    <section style={{
      background: '#050A12',
      padding: '100px 5%',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.04)'
    }}>
      {/* Background texture strip */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '3px',
        background: 'linear-gradient(90deg, #3B6FD4 0%, transparent 40%, #E8941A 70%, transparent 100%)'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Two-column layout */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'start' }}>

          {/* Left — Support channels */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <div style={{ width: '28px', height: '1px', background: '#E8941A' }} />
              <span style={{ fontFamily: 'monospace', fontSize: '0.6rem', letterSpacing: '0.3em', color: '#E8941A', textTransform: 'uppercase' }}>Støttekanaler</span>
            </div>
            <div style={{
              fontFamily: '"Arial Black", sans-serif',
              fontSize: 'clamp(2rem, 4vw, 3.5rem)',
              fontWeight: 900, color: '#EEF0F2',
              letterSpacing: '-0.04em', textTransform: 'uppercase',
              lineHeight: 0.9, marginBottom: '8px'
            }}>VI ER HER</div>
            <div style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: 'clamp(1.25rem, 2.5vw, 2rem)',
              color: '#3B6FD4', lineHeight: 1, marginBottom: '48px'
            }}>for deg alltid.</div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {channels?.map((ch, i) => (
                <div key={i} style={{
                  display: 'grid',
                  gridTemplateColumns: '56px 1fr',
                  gap: '0',
                  background: 'rgba(255,255,255,0.02)',
                  border: '1px solid rgba(255,255,255,0.04)',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    background: `${ch?.color}18`,
                    borderRight: `1px solid ${ch?.color}30`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '1.4rem', color: ch?.color
                  }}>{ch?.icon}</div>
                  <div style={{ padding: '18px 20px' }}>
                    <div style={{
                      fontFamily: '"Arial Black", sans-serif',
                      fontSize: '0.85rem', fontWeight: 900,
                      color: '#EEF0F2', letterSpacing: '-0.02em',
                      textTransform: 'uppercase', marginBottom: '4px'
                    }}>{ch?.title}</div>
                    <div style={{
                      fontFamily: 'Georgia, serif', fontStyle: 'italic',
                      fontSize: '0.8rem', color: 'rgba(238,240,242,0.45)',
                      lineHeight: 1.4, marginBottom: '6px'
                    }}>{ch?.desc}</div>
                    <div style={{
                      fontFamily: 'monospace', fontSize: '0.7rem',
                      color: ch?.color, letterSpacing: '0.05em'
                    }}>{ch?.detail}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Social + hours */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <div style={{ width: '28px', height: '1px', background: '#3B6FD4' }} />
              <span style={{ fontFamily: 'monospace', fontSize: '0.6rem', letterSpacing: '0.3em', color: '#3B6FD4', textTransform: 'uppercase' }}>Følg oss</span>
            </div>
            <div style={{
              fontFamily: '"Arial Black", sans-serif',
              fontSize: 'clamp(2rem, 4vw, 3.5rem)',
              fontWeight: 900, color: '#EEF0F2',
              letterSpacing: '-0.04em', textTransform: 'uppercase',
              lineHeight: 0.9, marginBottom: '8px'
            }}>SOSIALE</div>
            <div style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: 'clamp(1.25rem, 2.5vw, 2rem)',
              color: '#E8941A', lineHeight: 1, marginBottom: '48px'
            }}>medier.</div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px', marginBottom: '48px' }}>
              {social?.map((s, i) => (
                <div key={i} style={{
                  background: 'rgba(255,255,255,0.02)',
                  border: '1px solid rgba(255,255,255,0.04)',
                  padding: '20px',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                  display: 'flex', alignItems: 'center', gap: '14px'
                }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(59,111,212,0.08)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'}
                >
                  <div style={{
                    width: '36px', height: '36px',
                    background: 'rgba(59,111,212,0.15)',
                    border: '1px solid rgba(59,111,212,0.3)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontFamily: '"Arial Black", sans-serif',
                    fontSize: '0.65rem', fontWeight: 900,
                    color: '#3B6FD4', letterSpacing: '-0.02em',
                    flexShrink: 0
                  }}>{s?.symbol}</div>
                  <div>
                    <div style={{ fontFamily: '"Arial Black", sans-serif', fontSize: '0.75rem', fontWeight: 900, color: '#EEF0F2', letterSpacing: '-0.02em', textTransform: 'uppercase' }}>{s?.label}</div>
                    <div style={{ fontFamily: 'monospace', fontSize: '0.6rem', color: 'rgba(238,240,242,0.4)', letterSpacing: '0.05em', marginTop: '2px' }}>{s?.sub}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Hours magazine block */}
            <div style={{
              background: 'rgba(59,111,212,0.06)',
              border: '1px solid rgba(59,111,212,0.2)',
              padding: '28px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute', top: '-10px', right: '-10px',
                fontFamily: '"Arial Black", sans-serif',
                fontSize: '5rem', fontWeight: 900,
                color: 'rgba(59,111,212,0.06)',
                lineHeight: 1, userSelect: 'none'
              }}>24/7</div>
              <div style={{ fontFamily: 'monospace', fontSize: '0.55rem', letterSpacing: '0.25em', color: 'rgba(59,111,212,0.6)', textTransform: 'uppercase', marginBottom: '16px' }}>Åpningstider</div>
              {[
                ['Mandag – Fredag', '08:00 – 17:00'],
                ['Lørdag', '10:00 – 14:00'],
                ['Søndag', 'Stengt'],
                ['Helligdager', 'Stengt']
              ]?.map(([day, hours], i) => (
                <div key={i} style={{
                  display: 'flex', justifyContent: 'space-between',
                  alignItems: 'baseline',
                  borderBottom: i < 3 ? '1px solid rgba(255,255,255,0.04)' : 'none',
                  padding: '10px 0'
                }}>
                  <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '0.85rem', color: 'rgba(238,240,242,0.55)' }}>{day}</div>
                  <div style={{ fontFamily: '"Arial Black", sans-serif', fontSize: '0.8rem', fontWeight: 900, color: hours === 'Stengt' ? 'rgba(238,240,242,0.25)' : '#EEF0F2', letterSpacing: '-0.02em' }}>{hours}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportHours;
